<nb-card class="exercise_edit_container mobilePopup" #SelectionLayout1
  [ngClass]="ShowEditButtons ? 'nb_card_pop_up meal_item mobilePopup' : ''">

  <nb-card-header [hidden]="!ShowEditButtons">
    <div class="title">
      <ng-container i18n="@@AddNewItemToBlock">Edit Item</ng-container>
    </div>
    <div class="actions">
      <!--<button i18n="@@AddNewItem" type="submit" style="width:120px;z-index: 1000;" class="btn-circle btn-xl btn-main StandardGreenButton" (click)="onNewCustomMealItem()">Add New Item</button>-->

      <button nbButton ghost tabindex="-1">
        <nb-icon icon="close-outline" (click)="Close()" style="z-index: 1000;"></nb-icon>
      </button>

    </div>
  </nb-card-header>



  <nb-card-body style="overflow-x:hidden;">
    <form #myForm="ngForm">
      <div style="position:absolute; float:right; top:5px; right:5px; z-index:1000;">
        <select [(ngModel)]="FitnessItem.setsBased" style="font-size: 10pt; margin-bottom:5px" tabindex="-1" name="setsBased">
          <option [value]="SetsBased.RepsBased">Reps based</option>
          <option [value]="SetsBased.MaxRepBased">Max rep based</option>
          <option [value]="SetsBased.TimeBased">Time based</option>
          <option [value]="SetsBased.Superset">Superset</option>
        </select>
      </div>

      <div class="row exercise-edit-main-content">

        <div class="col-md-4 exercise-edit-image d-flex">
          <!-- [style.visibility]="isPlayingVideo ? 'visible':'hidden'" -->

          <div class="excercise-media-box" *ngIf="!FitnessItem.isQuickAdd">
            <video #video [controls]="isPlayingVideo" width="100%" *ngIf="isPlayingVideo" (ended)="onVideoEnded()">
              <source
                [src]="!FitnessItem.useFemaleVersion ? getVideoUrl(FitnessItem.videoUrl) : getVideoUrl(FitnessItem.femaleVideoUrl)"
                type="video/mp4">
              Your browser does not support the video tag. {{FitnessItem.femaleVideoUrl}}
            </video>
            <ng-container *ngIf="!isPlayingVideo">
              <img *ngIf="(FitnessItem.exerciseVideoThumbnailUrl && FitnessItem.exerciseVideoThumbnailUrl != 'null') else imageElse" [class.edit-modal-img]="ShowEditButtons"
                [src]="FitnessItem.exerciseVideoThumbnailUrl" />
              <ng-template #imageElse>
                <img *ngIf="!FitnessItem.useFemaleVersion && FitnessItem.imageUrl"
                  [class.edit-modal-img]="ShowEditButtons" id="not-female" [src]="FitnessItem.imageUrl" />
                <img *ngIf="FitnessItem.useFemaleVersion && FitnessItem.femaleImageUrl" id="female"
                  [class.edit-modal-img]="ShowEditButtons" [src]="FitnessItem.femaleImageUrl" />
              </ng-template>
            </ng-container>

            <!-- <img #image [src]="!FitnessItem.useFemaleVersion ? FitnessItem.imageUrl : FitnessItem.femaleImageUrl"
              *ngIf="!isPlayingVideo"/> -->
            <img src="/assets/images/play.png" class="play" (click)="onPlayVideo()"
              *ngIf="!isPlayingVideo && ((!FitnessItem.useFemaleVersion && FitnessItem.videoUrl) || (FitnessItem.useFemaleVersion && FitnessItem.femaleVideoUrl))">
          </div>
          <div *ngIf="FitnessItem.isQuickAdd" class="quick-add-custom-name-edit">{{FitnessItem.customName}}</div>
        </div>

        <div class="col-md-8 exercise-edit-settings" style="margin-left: 5px;">
          <div class="exercise-edit-name-row" style="border-bottom: 0px solid #e3e3e3" *ngIf="!FitnessItem.isQuickAdd">
            <span>{{FitnessItem.name}}</span>

            <div class="clearfix"></div>
          </div>

          <div class="exercise-edit-name-row" style="border-bottom: 0px solid #e3e3e3" *ngIf="FitnessItem.isQuickAdd">
            <input tabindex="-1" nbInput [(ngModel)]="FitnessItem.customName" (ngModelChange)="onChanged()" type="text"
              style="width: 80%; margin-bottom: 3px;" maxlength="50" name="customName"/>

            <div class="clearfix"></div>
          </div>

          <div *ngIf="IsSuperSetSlave" class="message-label" style="text-decoration: none; padding: 5px;">Some vales are
            driven by first superset exercice settings.</div>
          <div *ngIf="IsCircuitMode" class="message-label" style="text-decoration: none;padding: 5px;">Some vales are
            driven by first circuit settings.</div>

          <div class="exercise-edit-setting-row">


            <div class="setting-item" *ngIf="!IsCircuitMode && !IsSuperSetSlave">
              <label>Set</label>
              <input tabindex="-1" nbInput [(ngModel)]="FitnessItem.sets" (ngModelChange)="onChanged()" class="sets"
                pattern="[0-9]*" type="number" min="1" [disabled]="FitnessItem.showAdvancedMode" name="sets"/>
            </div>

            <div class="setting-item" *ngIf="IsCircuitMode && !IsSuperSetSlave">
              <label>Set</label>
              <input tabindex="-1" nbInput value="{{GetSupersetMaster ? GetSupersetMaster.sets : 1}}" class="sets"
                disabled type="number" min="1">
            </div>


            <div class="setting-item" *ngIf="IsSuperSetSlave">
              <label>Set</label>
              <input tabindex="-1" nbInput value="{{GetSupersetMaster ? GetSupersetMaster.sets : 1}}" class="sets"
                disabled type="number" min="1">
            </div>




            <div class="setting-item" *ngIf="!IsMaxRepType">
              <label>{{RepLabel}}</label>
              <input tabindex="-1"  nbInput [(ngModel)]="FitnessItem.defaultRepsOrTime" (ngModelChange)="onChanged()"
                pattern="^\d+(\.\d+)?$" class="sets" min="1" [disabled]="FitnessItem.showAdvancedMode" name="defaultRepsOrTime"/>
            </div>


            <div class="setting-item" *ngIf="IsMaxRepType">
              <label>{{RepLabel}}</label>
              <input tabindex="-1" nbInput [(ngModel)]="FitnessItem.defaultRepsOrTime" (ngModelChange)="onChanged()"
                class="sets" type="number" min="1" [disabled]="FitnessItem.showAdvancedMode" style="display:none;" name="defaultRepsOrTime2"/>
              <input tabindex="-1" nbInput value="Max" class="sets" disabled min="1">
            </div>
            <!--
            <div class="setting-item" *ngIf="IsSuperSetSlave">
              <label>{{RepLabel}}</label>
              <input tabindex="-1" nbInput [(ngModel)]="FitnessItem.defaultRepsOrTime" (ngModelChange)="onChanged()"
                class="sets" type="number" min="1" [disabled]="FitnessItem.showAdvancedMode" style="display:none;">
                <input tabindex="-1" nbInput value="{{GetSupersetMaster.defaultRepsOrTime}}" class="sets" disabled
                min="1">
            </div>-->
            <div class="setting-item">
              <label>Tempo</label>
              <input tabindex="-1" nbInput [(ngModel)]="FitnessItem.defaultTempo" (ngModelChange)="onChanged()"
                class="sets" min="1" [disabled]="FitnessItem.showAdvancedMode" name="defaultTempo" />
            </div>
            <div class="setting-item" *ngIf="!IsCircuitMode && !IsSuperSetSlave">
              <label>Rest (sec)</label>
              <input tabindex="-1" nbInput [(ngModel)]="FitnessItem.defaultRest" (ngModelChange)="onChanged()"
                class="sets" type="number" min="0" [disabled]="FitnessItem.showAdvancedMode" name="defaultRest"/>
            </div>
            <div class="setting-item" *ngIf="IsCircuitMode && !IsSuperSetSlave">
              <label>Rest (sec)</label>
              <input tabindex="-1" nbInput value="{{fitnessBlock.circuitRest}}" disabled class="sets" type="number"
                min="0">
            </div>

            <div class="setting-item" *ngIf="IsSuperSetSlave">
              <label>Rest (sec)</label>
              <input tabindex="-1" nbInput value="{{GetSupersetMaster ? GetSupersetMaster.defaultRest : 0}}" disabled
                class="sets" type="number" min="0">
            </div>


            <div class="setting-item">
              <select tabindex="-1" [(ngModel)]="FitnessItem.weightType" style="font-size:10pt; width: 85px;" name="weightType">
                <option [value]="WeightType.AbsoluteValue">Weight ({{IsPreferredUnitImperial ? 'lbs' : 'Kg'}})</option>
                <option [value]="WeightType.Procent1MR">% 1-MR</option>
              </select>
              <input tabindex="-1" nbInput [(ngModel)]="FitnessItem.defaultWeight"
                *ngIf="FitnessItem.weightType == WeightType.Procent1MR" class="sets" type="number" min="1"
                [disabled]="FitnessItem.showAdvancedMode" name="defaultWeight"/>
              <pounds-and-kg [(ngModel)]="FitnessItem.defaultWeight" [isImperial]="IsPreferredUnitImperial"
                *ngIf="FitnessItem.weightType == WeightType.AbsoluteValue" name="defaultWeight2"></pounds-and-kg>
            </div>

          </div>


          <div *ngIf="!IsCircuitMode && !IsSuperSetSlave">
            <div>
              <a style="color:darkblue; cursor:pointer;" (click)="toggleSettings()">
                <div *ngIf="!FitnessItem.showAdvancedMode"><span>Show Advanced Mode </span><span
                    style="margin-top:3px;">
                    <nb-icon icon="arrow-down-outline"></nb-icon>
                  </span></div>
                <div *ngIf="FitnessItem.showAdvancedMode"><span>Hide Advanced Mode </span><span style="margin-top:3px;">
                    <nb-icon icon="arrow-up-outline"></nb-icon>
                  </span></div>
              </a>
            </div>

          </div>
          <div class="row">

            <div class="col-12">
              <div class="exercise-edit-setting-detail-row" *ngIf="FitnessItem.showAdvancedMode">
                <table class="styled-table">
                  <thead>
                    <tr>
                      <th>Set</th>
                      <th *ngIf="this.FitnessItem.setsBased != SetsBased.MaxRepBased">{{RepLabel}}</th>
                      <th>Tempo</th>
                      <th>Rest (Sec.)</th>
                      <th>
                        Weight

                        <span *ngIf="FitnessItem.weightType == WeightType.Procent1MR">(%)</span>
                        <span *ngIf="FitnessItem.weightType != WeightType.Procent1MR">({{IsPreferredUnitImperial ? 'lbs'
                          : 'Kg'}})</span>

                      </th>
                    </tr>
                  </thead>

                  <tbody *ngIf="FitnessItem.showAdvancedMode">
                    <tr *ngFor="let row of settingDetails; let i = index;" [formGroup]="advanceOptionForm.at(i)">
                      <td width="20%">
                        {{row.Set}}
                      </td>
                      <td width="20%" *ngIf="FitnessItem.setsBased != SetsBased.MaxRepBased">
                        <small-smart-edit InputType="number" formControlName="RepsOrTime"
                          (customfocusout)="onAdvancedRepChange()" name="RepsOrTime"></small-smart-edit>
                      </td>
                      <td width="20%">
                        <small-smart-edit formControlName="Tempo" name="Tempo"></small-smart-edit>
                      </td>
                      <td width="20%">
                        <small-smart-edit InputType="number" formControlName="Rest" name="Rest"></small-smart-edit>
                      </td>
                      <td width="20%">
                        <small-smart-edit InputType="number" formControlName="Weight" name="Weight"></small-smart-edit>

                      </td>
                    </tr>
                  </tbody>

                </table>
                <div>
                  <a style="color:gray; cursor:pointer;font-size:small" (click)="resetSettings()">

                    <span>Reset</span><span style="margin-top:3px;">
                      <nb-icon icon="refresh-outline" style="font-size:small"></nb-icon>
                    </span>
                  </a>
                </div>

              </div>

              <div style="margin-top: 10px;">
                <div class="label">Additional Instructions</div>
                <smart-edit [(ngModel)]="FitnessItem.instructions" i18n-placeholder="@@Instructions"
                  placeholder="Instructions" [IsMultiLine]="true" [MaxLength]="500" [MultiLineHeight]="50"
                  [OpenByDefault]="true" name="instructions">
                </smart-edit>

              </div>

            </div>

          </div>

        </div>

      </div>

      <div class="row exercise-edit-footer align-items-end">

        <div class="col-md-6" style="margin-bottom:10px; margin-top:10px;">
          <div *ngIf="PatientID > 0">
            <div style="float:left; margin-right:10px;">
              <span>One Max Rep: </span><br />
              <span style="font-size:8pt; color:dimgray">{{PatientName}}</span>

            </div>

            <pounds-and-kg style="float:left; width:120px;" [(ngModel)]="FitnessItem.oneRepMax"
              [isImperial]="IsPreferredUnitImperial" name="oneRepMax"></pounds-and-kg>

          </div>
          <div>

          </div>
        </div>

        <!--<div class="include-rest col-md-6" style="margin-bottom:10px;">

          <div style="display:none">
            <nb-checkbox [(ngModel)]="IncludeRest">
              <span i18n="@@Include">Add rest after exercice.</span>
            </nb-checkbox>
            <div *ngIf="includeRest">
              <input [(ngModel)]="FitnessItem.restBeforeNextExercise" type="number" min="1" [disabled]="!includeRest">
              <span> seconds</span>
            </div>

          </div>
        </div>-->

        <div class="add-to-plan-container col-md-6" style="margin-bottom:10px;">

          <nb-checkbox i18n="@@UseFemaleVersion" class="float-left" (change)="onVideoChange()"
            [(ngModel)]="FitnessItem.useFemaleVersion" *ngIf="FitnessItem.imageNameFemale">Use Female Version
          </nb-checkbox>

          <button nbButton class="float-right btn-circle btn-xl btn-main btn-add-plan btn-circle btn-xl"
            (click)="onAdd()" [disabled]="!myForm.valid" type="button" [hidden]="ShowEditButtons">
            <nb-icon icon="plus-outline"></nb-icon> Add to Plan
          </button>
        </div>
      </div>
    </form>
  </nb-card-body>

  <nb-card-footer [hidden]="!ShowEditButtons">
    <table>
      <tr>
        <td>
          <button i18n="@@Save" nbButton class="btn-circle btn-xl btn-main btn-circle btn-xl"
            (click)="Save()">Save</button>
        </td>
        <td>
          <button i18n="@@Remove" nbButton class="back btn btn-circle btn-xl" (click)="Remove()">
            Remove <nb-icon icon="trash-2-outline"></nb-icon>
          </button>
        </td>
      </tr>
    </table>
  </nb-card-footer>

</nb-card>